import React from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
// import StripeBlock from './stripe-block';
import "./../../payments/payments.scss";
import { getSKeyValue } from "../../../utils/getSKey";
const stripePromise = loadStripe(getSKeyValue());
export default function StripeIntegration(props) {
  return (
    <div>
      <Elements stripe={stripePromise}>{/* <StripeBlock messageObj={props.messageObj} incPayment={props.incPayment} /> */}</Elements>
    </div>
  );
}
